import { pluralize } from '@/lib/format'
import type { OtsDriverSyncResult } from '@/types/api'

/** "3 created, 12 linked" — only the counts that moved. */
export function describeDriverSync(result: OtsDriverSyncResult): string {
  const parts = [
    [result.created, 'created'],
    [result.linked, 'linked'],
    [result.updated, 'updated'],
    [result.deactivated, 'suspended'],
    [result.reactivated, 'reactivated'],
  ]
    .filter(([count]) => (count as number) > 0)
    .map(([count, word]) => `${count} ${word}`)
  const read = `${result.fetched} ${pluralize(result.fetched, 'driver')} read from OTS`
  return parts.length > 0 ? `${read}: ${parts.join(', ')}.` : `${read}; nothing to change.`
}
